<template>
  <div class="fill-height">
    <template v-if="isArchivingEnabled">
      <router-view v-if="!configPending" v-slot="{ Component }">
        <transition name="app-fade">
          <component :is="Component" />
        </transition>
      </router-view>
      <div v-else class="d-flex align-center justify-center h-100">
        <v-progress-circular
          style="width: 64px; height: 64px"
          indeterminate
          color="primary"
          size="64"
        />
      </div>
    </template>
    <template v-else>
      <ArchivesPaywallDialog/>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { ArchivesActionTypes } from '@/store/modules/archives/action_types'

import ArchivesPaywallDialog from '../views/ArchivesPaywallDialog.vue'

const { mapActions, mapState } = createNamespacedHelpers('archives')
const { mapGetters: mapUserGetters } = createNamespacedHelpers('user')
export default {
  name: 'ArchivesLayout',
  components: {
    ArchivesPaywallDialog,
  },
  computed: {
    ...mapState(['configPending']),
    ...mapUserGetters(['isArchivingEnabled']),
  },
  created () {
    if (this.isArchivingEnabled) {
      // This is always used, so we fetch it here
      this.GET_ARCHIVE_CONFIG()
    }
  },
  methods: {
    ...mapActions([ArchivesActionTypes.GET_ARCHIVE_CONFIG]),
  },
}
</script>
